import React from 'react';
import { useAuth } from '../contexts/Auth/authContext';
import { useI18n } from '../contexts/I18nContext';
import config from '../config/env';

export const SignInPage: React.FC = () => {
  const { login } = useAuth();
  const { t } = useI18n();
  return (
    <div className="signin">
      <main className="signin-card">
        <img src={config.ui.logoUrl} alt="logo Anep" className="signin-logo" onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none';}} />
        <p className="signin-product">{config.ui.title}</p>
        <h1 className="signin-title">{t('auth.welcome')}</h1>
        <p className="signin-subtitle">{t('auth.signInSubtitle')}</p>
        <button type="button" className="signin-button" data-testid="btn-signin" onClick={login}>
          {t('auth.signInAction')}
        </button>
        <p className="signin-note">{t('auth.signInRedirectNote')}</p>
      </main>
    </div>
  );
};